export const TOOLS = {
  PENCIL: 'PENCIL',
  PALETTE: 'PALETTE',
  ERASE: 'ERASE',
  CLEAR: 'CLEAR',
  UNDO: 'UNDO',
  REDO: 'REDO',
  SELECTOR: 'SELECTOR',
  DOWNLOAD: 'DOWNLOAD',
  RECT: 'RECT',
  CIRCLE: 'CIRCLE',
  STAR: 'STAR',
  TRIANGLE: 'TRIANGLE',
  LINE: 'LINE'
}